<template>
  <div>
    <CRow class="content-fade-in" ref="container">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="12" xl="12">
                  <BaseTextArea :options="contentInput.options" :data="contentInput.data"
                                v-model="contentInput.data.model"/>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6" md="12" xl="12">
                  <BaseSelect
                    :options="groupSelect.options"
                    :data="groupSelect.data"
                    ref="voiceTypeSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol sm="6" md="12" xl="12">
                  <BaseSelect
                    :options="voiceTypeSelect.options"
                    :data="voiceTypeSelect.data"
                    ref="voiceTypeSelect"
                  >
                  </BaseSelect>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6" md="12" xl="12">
                  <BaseSelect
                    :options="speedSelect.options"
                    :data="speedSelect.data"
                    ref="speedSelect"
                  >
                  </BaseSelect>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6" md="12" xl="12">
                  <BaseSelect
                    :options="formatSelect.options"
                    :data="formatSelect.data"
                    ref="formatSelect"
                  >
                  </BaseSelect>
                </CCol>
              </CRow>
              <CRow>
                <label></label>
              </CRow>
              <CRow v-show="url != null && url != ''">
                <CCol sm="6" md="12" xl="12">
                  <CCard style="margin-bottom: 0!important;">
                    <CCardHeader color="success">
                      Tệp chuyển đổi
                    </CCardHeader>
                    <CCardBody>
                      <CRow>
                        <audio controls aria-label="Tệp chuyển đổi" class="audio-css" ref="audio">
                          <source :src="url" type="audio/mpeg">
                          <source :src="url" type="audio/wav">
                        </audio>
                        <CButton color="success" class="btn-action-primary ml-2"
                                 @click="downloadByUrl()"><i class="fa fa-download"></i> Tải xuống
                        </CButton>
                        <CButton color="primary" class="btn-action-primary ml-2" @click="clickAddFile()"><i
                          class="fa fa-file"></i> Biên tập
                        </CButton>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <div slot="footer">
                  <CButton
                    color="primary"
                    class="btn-action-primary mr-2"
                    @click="submitData">
                    <i class="fa fa-plus"></i> Chuyển đổi
                  </CButton>

                  <CButton
                    color="secondary"
                    class="btn-action-primary mr-2"
                    @click="resetData()"><i class="fa fa-eraser"></i> Làm mới
                  </CButton>
                </div>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
        <BaseAudioAddFile v-if="isShowFileAdd" :file="fileAddContent" :duration="durationFileAdd"
                          @loading="loadingAdd($event)" :type="fileType"></BaseAudioAddFile>
      </CCol>
      <BaseLoading :loading="loading.value"></BaseLoading>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea.vue";
import BaseAudioAddFile from "../base/BaseAddFile.vue";
import {FileType} from "@/constant";

export default {
  name: "TextToSpeech",
  components: {BaseSelect, BaseInput, BaseLoading, BaseTextArea, BaseAudioAddFile},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    var that = this;
    return {
      fileType: FileType.CHUYEN_DOI_VAN_BAN,
      loading: {value: false},
      fileAddContent: {
        fileName: '',
        content: '',
      },
      durationFileAdd: '',
      isShowFileAdd: false,
      url: '',
      groupSelect: {
        options: {
          label: "Nhà cung cấp <span class='required'>*</span>",
          filter: false,
          'keyField': 'id',
          'valueField': 'name',
          selectAllText: 'Chọn nhà cung cấp'
        },
        data: {
          name: "group",
          model: null,
          source: {
            url: "/textToSpeech/voiceGroup",
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.groupSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Nhà cung cấp không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      voiceTypeSelect: {
        options: {
          label: "Giọng đọc <span class='required'>*</span>",
          'keyField': 'id',
          'valueField': 'name',
          selectAllText: 'Chọn giọng đọc',
          lazyLoad: true,
        },
        data: {
          name: "voiceVnStyle",
          model: null,
          source: {
            url: "/textToSpeech/voiceType",
            isJsonContentType: false,
            dataSubmit: function () {
              return {
                configId: that.groupSelect.data.model,
              };
            },
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.voiceTypeSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Giọng đọc không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      speedSelect: {
        options: {
          label: "Tốc độ đọc <span class='required'>*</span>",
          filter: false,
          'keyField': 'id',
          'valueField': 'name',
          selectAllText: 'Chọn tốc độ đọc',
          lazyLoad: true,
        },
        data: {
          name: "speedId",
          model: null,
          source: {
            url: "/textToSpeech/speed",
            isJsonContentType: false,
            dataSubmit: function () {
              return {
                configId: that.groupSelect.data.model,
              };
            },
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.speedSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tốc độ đọc không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      speed: {
        data: {
          name: "speed"
        }
      },
      formatSelect: {
        options: {
          label: "Loại tệp",
          filter: false
        },
        data: {
          name: "format",
          items: [
            {key: "mp3", value: "MP3"},
            {key: "wav", value: "WAV"},
          ],
          model: "mp3"
        }
      },
      contentInput: {
        options: {
          label: "Nội dung <span class='required'>*</span>",
          placeholder: "Nội dung (tối đa 5000 kí tự)",
          type: "text",
          maxlength: 5000,
          rows: 16
        },
        data: {
          name: "content",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.contentInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Nội dung không được để trống";
              } else if (value.length > 5000) {
                this.isValid = false;
                this.errorMessage = "Nội dung không quá 5000 kí tự";
              } else if (value.length < 4) {
                this.isValid = false;
                this.errorMessage = "Nội dung phải từ 4 kí tự";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/textToSpeech/textToSpeech",
        isJsonContentType: false,
        dataRef: function () {
          return that.$data;
        },
        successCallback: async function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            const blob = await that.$helper.fetchToBlob(response.data.data.url);
            let url = URL.createObjectURL(blob);
            that.url = url;
            that.$refs.audio.load();

            let base64 = await that.$helper.blobToBase64(blob);
            var audio = document.createElement('audio');
            audio.src = url;
            audio.addEventListener('loadedmetadata', function () {
              var duration = new Date(audio.duration * 1000).toISOString().substr(11, 8);
              that.durationFileAdd = duration;
            }, false);
            that.fileAddContent.content = base64;
            that.fileAddContent.fileName = response.data.data.fileName;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    resetData() {
      let that = this;
      that.$helper.setupDataResponse(that.$data, {});
      that.formatSelect.data.model = 'mp3';
      that.speedSelect.data.model = '0';
      that.isShowFileAdd = false;
    },
    downloadByUrl() {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = this.fileAddContent.content;
      a.download = this.fileAddContent.fileName;
      a.click();
    },
    clickAddFile() {
      let that = this;
      this.isShowFileAdd = true;
      setTimeout(() => {
        let container = that.$refs.container;
        window.scrollTo({left: 100, top: container.scrollHeight, behavior: "smooth"});
      }, 200);
    },
    loadingAdd(value) {
      if (value) {
        this.loading.value = true;
      } else {
        this.loading.value = false;
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    'groupSelect.data.model': function (value) {
      var that = this;
      if (value) {
        that.$refs.voiceTypeSelect.loadData();
        that.$refs.speedSelect.loadData();
        that.voiceTypeSelect.data.model = null;
        that.speedSelect.data.model = null;
      } else {
        that.voiceTypeSelect.data.model = null;
        that.speedSelect.data.model = null;
      }
    },
  }
};
</script>
